Ext.define('SA.data.Query', {
    alias: 'query.query',
    isQuery: true,

    statics: {
        MAX_LIMIT: 10000,

        from(cfg) {
            if (cfg.isQuery) {
                return cfg;
            }

            return Ext.createByAlias('query.' + cfg.type, cfg);
        }
    },

    limit: 0,
    start: 0,

    constructor(cfg) {
        Object.assign(this, cfg);

        this.failure = new SA.data.CallbackSet();
        this.success = new SA.data.CallbackSet();
    },

    addFailure(fn, scope) {
        var response = this.response;

        if (response || this.isDestroyed) {
            return;
        }

        this.failure.add(fn, scope);

        if (response === false) {
            setTimeout(this.fireFailure.bind(this), 10);
        }
    },

    addSuccess(fn, scope) {
        var response = this.response;

        if (response === false || this.isDestroyed) {
            return;
        }

        this.success.add(fn, scope);

        if (response) {
            setTimeout(this.fireSuccess.bind(this), 10);
        }
    },

    cancel() {
        this.destroy();
    },

    createParams() {
        var fields = this.fields,
            facets = this.facets,
            where = this.where,
            aggregates = this.aggregates,
            sort = this.sort,
            filter = this.filter,
            data = {
                slice: [this.start, this.limit]
            };

        if (where && where.length) {
            data[this.whereProperty] = where;
        }

        if (aggregates && aggregates.length) {
            data.aggregates = aggregates;
        }

        if (filter) {
            data.filter = filter;
        }

        if (fields) {
            data[this.fieldsProperty] = fields;
        }

        if (facets) {
            data.facets = facets;
        }

        if (sort && sort.length) {
            if (!Array.isArray(sort[0])) {
                sort = [sort];
            }

            data.sort = sort;
        }

        if (this.total) {
            data.total = true;
        }

        return {
            data,
            method: 'get',
            resource: this.resource
        };
    },

    destroy() {
        this.isDestroyed = true;

        Ext.destroyMembers(this, 'failure', 'success');
    },

    fireFailure() {
        this.success.clear();
        this.failure.run(this);
    },

    fireSuccess() {
        this.failure.clear();
        this.success.run(this, [this.response]);
    },

    getHash() {
        return JSON.stringify(this.getParams());
    },

    getParams() {
        return this.params || (this.params = this.createParams());
    },

    isPending() {
        return this.response === undefined;
    },

    mapResult(result) {
        var obj = {};

        result.forEach((resultItem, index) => {
            var field = this.fields[index],
                fieldName = Array.isArray(field) ? field[field.length - 1] : field;

            obj[fieldName] = resultItem;
        });

        return obj;
    },

    onFailure(error) {
        if (!this.isDestroyed) {
            this.response = false;

            this.fireFailure();
        }

        error.flagUnexpected();
    },

    onSuccess(response) {
        if (this.isDestroyed) {
            return;
        }

        if (this.responseMapper) {
            this.response = this.responseMapper(response);
            this.fireSuccess();
            return;
        }

        var isArray = Array.isArray(response),
            results = isArray ? response : response.hits || response.data || [];

        results = results.map(this.mapResult, this);

        if (isArray) {
            this.response = results;
        }
        else {
            let facets = response.facets || [],
                total = +(response.totalHits || response.total || 0);

            this.response = {facets, results, total};
        }

        this.fireSuccess();
    },

    run() {
        this.promise = this.promise || SA.Ajax.request(Object.assign({
            failure: this.onFailure,
            scope: this,
            success: this.onSuccess
        }, this.getParams()));

        return this.promise;
    },

    setResponseMapper(responseMapper) {
        this.responseMapper = responseMapper;
    }
});
